export default "<p>precios works!</p>\n"